/**
 * Case-insensitive string comparator for AG Grid column sorting.
 */
export const caseInsensitiveComparator = (a: string | null, b: string | null): number =>
	(a ?? "").localeCompare(b ?? "", undefined, { sensitivity: "base" });
